export function Reducer(state, action) {
  switch (action.type) {
    case "load":
      return {
        ...state,
        invoices: action.invoices,
      };
    case "pay":
      return {
        ...state,
        invoices: state.invoices.map((invoice) => {
          return invoice.id == action.invoice.id ? action.invoice : invoice;
        }),
      };
    default:
      throw new Error();
  }
}
